const errors = {
  email: {
    en: 'Enter a valid e-mail address',
    de: 'Gib eine gültige E-Mail-Adresse ein',
  },
  phone: {
    en: 'Enter a valid phone number',
    de: 'Geben Sie eine gültige Rufnummer ein',
  },
  password: {
    en: 'Password must be 8 or more characters',
    de: 'Passwort muss 8 oder mehr Zeichen haben',
  },
  otp: {
    en: 'OTP must be 4 digits',
    de: 'OTP muss 4 stellig sein',
  },
  password_mismatch: {
    en: 'Password does not match',
    de: 'Passwort passt nicht',
  },
  email_mismatch: {
    de: 'E-Mail stimmt nicht überein',
    en: 'Email mismatch',
  },
  number: {
    en: 'Value must be of type number',
    de: 'Wert muss vom Typ Zahl sein',
  },
  positive: {
    en: 'Value must be a positive number and greater than 0',
    de: 'Wert muss eine positive Zahl sein und größer als 0',
  },
  payment: {
    en: 'Please select a payment method',
    de: 'Bitte eine Zahlungsmethode auswählen',
  },
  char_limit: {
    en: 'Maximum character limit exceeded',
    de: 'Die maximale Zeichenzahl wurde überschritten',
  },
  first_name_min: {
    en: 'Please enter your first name',
    de: 'Bitte gib deinen Vornamen ein',
  },
  first_name_max: {
    en: 'First name can be max. 100 characters long',
    de: 'Vorname kann max. 100 Zeichen lang sein',
  },
  last_name_min: {
    en: 'Please enter your last name',
    de: 'Bitte gib deinen Nachnamen ein',
  },
  last_name_max: {
    en: 'Last name can be max. 100 characters long',
    de: 'Nachname kann max. 100 Zeichen lang sein',
  },
  name_min: {
    en: 'Name must be at least 1 character long',
    de: 'Name muss mindestens 1 Zeichen lang sein',
  },
  name_max: {
    en: 'Name can be max. 100 characters long',
    de: 'Name kann max. 100 Zeichen lang sein',
  },
  required: {
    en: 'Required',
    de: 'erforderlich',
  },
  min_cashout_balance_required: {
    en: 'Minimum withdraw balance is required',
    de: 'Mindest Auszahlungsbetrag ist erforderlich',
  },
  exceed_cashout_balance: {
    en: 'Entered amount exceeds your balance',
    de: 'Eingegebener Betrag überschreitet Ihr Guthaben.',
  },
  image: {
    en: 'Select image',
    de: 'Bild auswählen',
  },
  image_size: {
    en: 'Image must be less than 2 MB',
    de: 'Das Bild muss weniger als 2 MB groß sein',
  },
  image_format: {
    en: 'Image format must be jpg, jpeg or png',
    de: 'Bildformat muss jpg, jpeg oder png sein',
  },
  message: {
    de: 'Limit muss vom Typ Zahl sein',
    en: 'Limit must be of type number',
  },
};

export default errors;
